import { useEffect } from 'react';
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares';
import { Configure, useInstantSearch } from 'react-instantsearch-hooks-web';
import aa from 'search-insights';
import { v4 as uuidv4 } from 'uuid';
import { ANONYMOUS_USER_TOKEN, LAST_ALGOLIA_QUERY_ID } from '@loomstateorg/shared-frontend/constants/localStorage';
import useAccount from '@loomstateorg/shared-frontend/hooks/useAccount';

const InsightsMiddleware: React.FC = () => {
  const {
    use,
    results: { queryID },
  } = useInstantSearch();

  const { account } = useAccount();

  useEffect(() => {
    const middleware = createInsightsMiddleware({
      insightsClient: aa,
      onEvent({ insightsMethod, payload }, insightsClient) {
        const isExcluded = ['Hits Viewed'].includes((payload as any).eventName);

        if (!insightsMethod || isExcluded) return;

        insightsClient(insightsMethod, payload as any);
      },
    });

    return use(middleware as any);
  }, [use]);

  useEffect(() => {
    if (account?.accountId) aa('setUserToken', account.accountId);
    else {
      const token = window.localStorage.getItem(ANONYMOUS_USER_TOKEN);

      if (token) aa('setUserToken', token);
      else {
        const randomToken = uuidv4();
        window.localStorage.setItem(ANONYMOUS_USER_TOKEN, randomToken);
        aa('setUserToken', randomToken);
      }
    }
  }, [account?.accountId]);

  useEffect(() => {
    if (queryID) window.localStorage.setItem(LAST_ALGOLIA_QUERY_ID, queryID);
  }, [queryID]);

  return (
    <>
      <Configure {...({ clickAnalytics: true } as any)} />
    </>
  );
};

export default InsightsMiddleware;
